// @suite/contracts-kernel — the "por vencer" threshold of every expiring item
// type: an item is "por vencer" from `warning_days` days before it expires
// (1..365, database default 30). Shared by RRHH (employee document, training and
// EPP types) and LOCX (vehicle document types), so every backend route and
// frontend form validates the same range.

import { z } from 'zod';

export const WARNING_DAYS_MIN = 1;
export const WARNING_DAYS_MAX = 365;
/** What a type gets when the form leaves the field out (the previous fixed window). */
export const WARNING_DAYS_DEFAULT = 30;

export const WarningDaysSchema = z.number().int().min(WARNING_DAYS_MIN).max(WARNING_DAYS_MAX);
